export const MAX_YOUNGSTER_AGE = 27;
export const CHANNEL_ID = 30;
export const INSURANCE_PRICE = 250;
const env = (
  import.meta as unknown as { env: Record<string, string | undefined> }
).env;

export const IS_TESTEABLE = env.VITE_TESTEABLE === "true";
export const MIXPANEL_TOKEN = env.VITE_MIXPANEL_TOKEN;
export const MIXPANEL_ENABLED = env.VITE_MIXPANEL_ENABLED !== "false";
export const PIXEL_ID = env.VITE_META_PIXEL_ID;
export const ACCESS_TOKEN = env.VITE_META_ACCESS_TOKEN;
export const APP_VERSION = env.VITE_APP_VERSION;
export const IS_TEST_PROD = env.VITE_PROD_TEST === "true";
export const APPLYING_BIOMETRIC =
  env.VITE_APPLYING_BIOMETRIC_ENROLLMENT === "true";
export const DISABLE_OBP_FLOW = env.VITE_DISABLE_OBP_FLOW === "true";
export const OBP_UNAVAILABLE_MESSAGE =
  "Momentáneamente este producto no está disponible. Comunicate con el banco al 132 para más información.";
export const APP_ENVIRONMENT = env.VITE_ENVIRONMENT;
export const APPLY_COLLEGE = env.VITE_APPLY_COLLEGE === "true";
export const APPLY_INSURANCE = env.VITE_APPLY_INSURANCE === "true";
export const EVENTS_TO_META = env.VITE_EVENTS_TO_META === "true";
export const APPLY_OTP_CONTACT_VALIDATION =
  env.VITE_APPLY_OTP_CONTACT_VALIDATION === "true";
